import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { ArrowLeft, ArrowRight, Loader2 } from 'lucide-react';
import StarRating from './StarRating';
import { categoryHint } from './categoryHints';

/*
 * Verfeinerung — bewusst NUR Sterne (Feedback 04.09., 32:46 / 54:28):
 * - Sterne sind mit dem Impuls-Wert aus Schritt 1 vorbelegt (#23)
 * - unter jeder Zeile ein kurzer Erklärsatz zur gewählten Sternzahl (#22, kein Tooltip)
 * - keine Textbox mehr; der Text kommt im nächsten Schritt als KI-Vorschlag (#24)
 * - kein Live-Durchschnitt, damit niemand die Sterne "auf ein Ergebnis hin" schiebt
 */
export default function CategoriesStep({ categories, onCategoryRating, onSubmit, analyzing, onBack }) {
  return (
    <motion.div
      key="negative-categories"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-4"
    >
      <Card className="card-shadow">
        <CardHeader className="pt-6 pb-3">
          <CardTitle className="text-xl">Helfen Sie uns, Ihr Feedback zu verstehen</CardTitle>
          <p className="text-sm text-muted-foreground mt-1">
            Wie sehen Sie die einzelnen Bereiche? Ihre Sterne aus dem ersten Schritt sind vorausgewählt.
          </p>
        </CardHeader>
        <CardContent className="space-y-4 pb-6">
          {categories.map((category) => (
            <div key={category.key} className="py-1">
              <div className="flex items-center justify-between gap-4">
                <span className="text-sm font-medium">{category.label}</span>
                <StarRating
                  rating={category.rating}
                  onChange={(r) => onCategoryRating(category.key, r)}
                  testIdPrefix={`negative-flow-category-${category.key}`}
                />
              </div>
              <p className="text-[11px] text-muted-foreground mt-0.5 min-h-[14px] sm:text-right">
                {categoryHint(category.key, category.rating)}
              </p>
            </div>
          ))}
        </CardContent>
      </Card>

      <div className="flex gap-3">
        <Button variant="secondary" onClick={onBack} className="flex-1">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück
        </Button>
        <Button onClick={onSubmit} disabled={analyzing} className="flex-1" data-testid="negative-flow-submit-categories">
          {analyzing ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <ArrowRight className="w-4 h-4 mr-2" />}
          Weiter
        </Button>
      </div>
    </motion.div>
  );
}
